import React, { useState } from 'react';
import '../styles/styles.css';
import { postUser } from '../services/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import PasswordInput from './PasswordInput';

const CrearUsuario = () => {
    const [email, setEmail] = useState('');
    const [permiso, setPermiso] = useState('user');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const navigate = useNavigate();
    const passwordRegex = /^(?=.{8,60}$)(?=.*[A-Z])(?=.*\d).*$/;


    const handleCrearUsuario = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            toast.error('Las contraseñas no coinciden,intentelo de nuevo');
            return;
        }

        if (!passwordRegex.test(password)) {
            toast.error('La contraseña debe tener entre 8 y 60 caracteres, al menos una mayúscula y un número.');
            return;
        }

        const payload = {
            email: email.trim(),
            permiso,
            password
        };
        try {
            const { data } = await postUser(payload);
            toast.success(data?.message ?? 'Usuario creado');
            navigate('/admin');
        } catch (error) {
            console.error('Error al crear usuario:', error.response?.data);
            toast.error(error.response?.data?.error || ' No se pudo crear el usuario');
        }
    };

    return (
        <div className='content-wrapper'>
            <h1>Nuevo Usuario </h1>
            <div className="container">
                <form onSubmit={handleCrearUsuario}>
                    <div className="form-group">
                        <label>Email <span className='required-text' >*Obligatorio</span></label>
                        <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label>Permiso <span className='required-text' >*Obligatorio</span></label>
                        <select className="form-control" value={permiso} onChange={(e) => setPermiso(e.target.value)}>
                            <option value="user">User</option>
                            <option value="admin">Admin</option>
                        </select>
                    </div>
                    
                    <PasswordInput
                        label="Contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <PasswordInput
                        label="Confirmar Contraseña"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <button type="submit" className="btn-create">Crear</button>
                </form>
            </div>

        </div>

    );
};
export default CrearUsuario;